// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__UsziS","nav-burger-menu":"Header_nav-burger-menu__gJ6s+","close":"Header_close__qs1ff"};